var React = require('react');

function MediumIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.1842 17.049L24 18.7293V18.785H14.7895V18.7293L16.6381 17.049C16.8353 16.8935 16.9297 16.6465 16.8846 16.404V5.66178C16.8846 5.20788 16.8846 4.59472 16.9668 4.06915L10.7552 19H10.6813L4.24786 5.26362C4.10818 4.92121 4.0671 4.89732 3.97672 4.66639V13.6727C3.8997 14.2755 4.00533 14.8869 4.28073 15.4325L6.86888 18.7293V18.785H0V18.7293L2.58815 15.4246C2.86152 14.8812 2.96709 14.2728 2.89216 13.6727V3.71878C2.93424 3.22867 2.78139 2.74151 2.46491 2.35708L0.63266 0.0557418V0H7.20575L12.7107 11.6341L17.5584 0H23.9918V0.0557418L22.1842 2.00671C21.9676 2.16018 21.8594 2.41932 21.9048 2.67561V16.404C21.8569 16.6538 21.9667 16.9072 22.1842 17.049Z","fill":"currentColor"}));
}

MediumIcon.defaultProps = {"width":"24","height":"19","viewBox":"0 0 24 19","fill":"none"};

module.exports = MediumIcon;

MediumIcon.default = MediumIcon;
